import { render } from "./TiptapEditor.vue?vue&type=template&id=2c4a1a1e"
import script from "./TiptapEditor.vue?vue&type=script&lang=js"
export * from "./TiptapEditor.vue?vue&type=script&lang=js"

import "./TiptapEditor.vue?vue&type=style&index=0&id=2c4a1a1e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__